export default __webpack_public_path__ + "static/media/diversity-dk.5518422f.svg";